import { IDepartmentOptions } from './interfaces/user';

interface IDepartment {
    phone?: string;
    fax?: string;
}
interface IVehicleRemarketing extends IDepartment {
    leaseEndInspections?: IDepartment;
    payoffRetailLease?: IDepartment;
}

interface IBrand {
    credit?: IDepartment;
    customerExperience?: IDepartment;
    dealerSupport: IDepartment;
    funding?: IDepartment;
    vehicleRemarketing?: IVehicleRemarketing;
    departmentOptions?: IDepartmentOptions;
}

interface ICountry {
    audi: IBrand;
    ducati: IBrand;
    helpdesk: IDepartment;
    vw: IBrand;
}
const us: ICountry = {
    audi: {
        credit: {
            phone: '888-464-2834',
        },
        customerExperience: {
            fax: '800-229-5076',
            phone: '888-237-2834',
        },
        dealerSupport: {
            phone: '888-464-2834',
        },
        funding: {
            phone: '888-464-2834',
        },
        vehicleRemarketing: {
            leaseEndInspections: {
                phone: '844-889-8529',
            },
            phone: '877-557-6824',
        },
        departmentOptions: {
            credit: '2',
            funding: '3',
            dealerSupport: '4',
            deTechService: '5',
        },
    },
    ducati: {
        credit: {
            phone: '855-382-2847',
        },
        customerExperience: {
            fax: '800-229-5076',
            phone: '855-938-2284',
        },
        dealerSupport: {
            phone: '855-382-2847',
        },
        funding: {
            phone: '855-382-2847',
        },
        vehicleRemarketing: {
            payoffRetailLease: {
                fax: '847-281-4205',
                phone: '888-464-2834',
            },
            phone: '877-557-6824',
        },
        departmentOptions: {
            credit: '1',
            funding: '2',
            dealerSupport: '3',
            deTechService: '4',
        },
    },
    helpdesk: {
        phone: '888-464-2834',
    },
    vw: {
        credit: {
            phone: '800-428-9227',
        },
        customerExperience: {
            fax: '800-229-5076',
            phone: '800-428-4034',
        },
        dealerSupport: {
            phone: '800-428-9227',
        },
        funding: {
            phone: '800-428-9227',
        },
        vehicleRemarketing: {
            phone: '877-557-6824',
        },
        departmentOptions: {
            credit: '2',
            funding: '3',
            dealerSupport: '4',
            deTechService: '5',
        },
    },
};

const ca: ICountry = {
    audi: {
        credit: {
            phone: '988-464-2834',
            fax: '988-464-2834',
        },
        customerExperience: {
            fax: '900-229-5076',
            phone: '988-237-2834',
        },
        dealerSupport: {
            phone: '(877) 268-2834',
            fax: '988-586-2834',
        },
        funding: {
            phone: '988-464-2834',
        },
        vehicleRemarketing: {
            leaseEndInspections: {
                phone: '944-889-8529',
            },
            phone: '977-557-6824',
        },
        departmentOptions: {
            credit: '3',
            funding: '4',
            lease: '5',
            customerService: '6',
        },
    },
    ducati: {
        credit: {
            phone: '955-382-2847',
        },
        customerExperience: {
            fax: '900-229-5076',
            phone: '955-938-2284',
        },
        dealerSupport: {
            phone: '(800) 667-8224',
        },
        funding: {
            phone: '955-382-2847',
        },
        vehicleRemarketing: {
            payoffRetailLease: {
                fax: '947-281-4205',
                phone: '988-464-2834',
            },
            phone: '877-557-6824',
        },
        departmentOptions: {
            credit: '3',
            funding: '4',
            customerService: '6',
        },
    },
    helpdesk: {
        phone: '988-464-9685',
        fax: '988-785-2834',
    },
    vw: {
        credit: {
            phone: '900-428-9227',
        },
        customerExperience: {
            fax: '900-229-5076',
            phone: '900-428-4034',
        },
        dealerSupport: {
            phone: '(800) 667-8224',
        },
        funding: {
            phone: '900-428-9227',
        },
        vehicleRemarketing: {
            phone: '977-557-6824',
        },
        departmentOptions: {
            credit: '3',
            funding: '4',
            lease: '5',
            customerService: '6',
        },
    },
};

export const contactInformation = {
    us,
    ca,
};
